// src/App.js
import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./App_funciona"; // o App_funciona

const AboutUs = lazy(() => import("./components/pages/AboutUs"));
const Contactanos = lazy(() => import("./components/pages/Contactanos"));
const Celebraciones = lazy(() => import("./components/pages/CustomEvents"));
const FantasyBall = lazy(() => import("./components/pages/FantasyBall"));
const LiteraryEvents = lazy(() => import("./components/pages/LiteraryEvents"));
const PoliticaPrivacidad = lazy(() => import("./components/privacity/PoliticaPrivacidad"));
const AvisoLegal = lazy(() => import("./components/privacity/AvisoLegal"));
const PoliticaCookies = lazy(() => import("./components/privacity/PoliticaCookies"));
const FaqPage = lazy(() => import("./components/privacity/FaqPage"));
const Linktree = lazy(() => import("./components/utils/LinkTree"));
const NocheCountry = lazy(() => import("./components/pages/nocheCountry"));
const BingoLiterario = lazy(() => import("./components/pages/BingoLiterario"));
const LectorasYVillanas = lazy(() => import("./components/pages/LectorasYVillanas"));
const Blog = lazy(() => import("./components/pages/blog/Blog"));
const BlogPost = lazy(() => import("./components/pages/blog/BlogPost"));
const AdminBlog = lazy(() => import("./components/pages/blog/AdminBlog"));

export default function App() {
  return (
    <Router>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nosotras" element={<AboutUs />} />
          <Route path="/contactanos" element={<Contactanos />} />
          <Route path="/celebraciones" element={<Celebraciones />} />
          <Route path="/bailes" element={<FantasyBall />} />
          <Route path="/eventos" element={<LiteraryEvents />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
          <Route path="/aviso-legal" element={<AvisoLegal />} />
          <Route path="/politica-cookies" element={<PoliticaCookies />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/linktree" element={<Linktree />} />
          <Route path="/eventos/noche-country" element={<NocheCountry />} />
          <Route path="/eventos/bingo-literario" element={<BingoLiterario />} />
          <Route path="/eventos/lectoras-y-villanas" element={<LectorasYVillanas />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:type/:slug" element={<BlogPost />} />
          <Route path="/admin" element={<AdminBlog />} />
        </Routes>
      </Suspense>
    </Router>
  );
}